import { Tick02Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { Label } from '@/components/ui/label'

import type { ResourceFilterOption } from './types'

const optionRowClassName = (selected: boolean) =>
  clsx(
    'flex w-full items-center justify-between gap-2 rounded-lg px-3 py-2.5 text-left text-sm font-medium transition-colors',
    selected
      ? 'bg-[color-mix(in_srgb,var(--color-brand)_10%,white)] text-[var(--color-brand)]'
      : 'text-gray-800 hover:bg-gray-50 active:bg-gray-100'
  )

type ResourceFilterOptionListProps<T extends string | number> = {
  label: string
  emptyLabel: string
  options: ResourceFilterOption<T>[]
  value: T | null | undefined
  onChange: (value: T | null) => void
}

/** Lista de opções para filtros avançados no mobile (bottom sheet). */
export const ResourceFilterOptionList = <T extends string | number>({
  label,
  emptyLabel,
  options,
  value,
  onChange
}: ResourceFilterOptionListProps<T>) => {
  if (options.length === 0) return null

  return (
    <div className="flex flex-col gap-2">
      <Label className="text-2xs font-bold uppercase tracking-wide text-gray-600">
        {label}
      </Label>
      <div className="flex max-h-40 flex-col gap-0.5 overflow-y-auto overscroll-contain rounded-xl border-2 border-contour bg-white p-1">
        <button
          type="button"
          onClick={() => onChange(null)}
          className={optionRowClassName(value == null)}
        >
          <span>{emptyLabel}</span>
          {value == null && <Tick02Icon size={16} aria-hidden />}
        </button>
        {options.map(option => (
          <button
            key={String(option.id)}
            type="button"
            onClick={() => onChange(option.id)}
            className={optionRowClassName(value === option.id)}
          >
            <span className="min-w-0 truncate">{option.label}</span>
            {value === option.id && <Tick02Icon size={16} aria-hidden />}
          </button>
        ))}
      </div>
    </div>
  )
}

ResourceFilterOptionList.displayName = 'ResourceFilterOptionList'
